"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _polished = require("polished");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _templateObject;
function cov_19ptvhg23f() {
  var path = "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductDescriptionIcon.js";
  var hash = "1a76a66eaba31d7580f64eb934f0b662f5107889";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductDescriptionIcon.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 18
        },
        end: {
          line: 7,
          column: 34
        }
      },
      "1": {
        start: {
          line: 9,
          column: 31
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 95
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 14
          }
        },
        loc: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 95
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 17
          },
          end: {
            line: 11,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 18
          },
          end: {
            line: 11,
            column: 29
          }
        }, {
          start: {
            line: 11,
            column: 33
          },
          end: {
            line: 11,
            column: 49
          }
        }, {
          start: {
            line: 11,
            column: 53
          },
          end: {
            line: 11,
            column: 75
          }
        }, {
          start: {
            line: 11,
            column: 80
          },
          end: {
            line: 11,
            column: 94
          }
        }],
        line: 11
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1a76a66eaba31d7580f64eb934f0b662f5107889"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19ptvhg23f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_19ptvhg23f();
var _ref = (cov_19ptvhg23f().s[0]++, _stylingConstants.default),
  color = _ref.color;
var ProductDescriptionIcon = (cov_19ptvhg23f().s[1]++, (0, _styledComponents.default)(_icon.default).attrs({
  iconColor: function iconColor(props) {
    cov_19ptvhg23f().f[0]++;
    cov_19ptvhg23f().s[2]++;
    return (0, _polished.lighten)(0.2, (cov_19ptvhg23f().b[0][0]++, props.theme) && (cov_19ptvhg23f().b[0][1]++, props.theme.icon) && (cov_19ptvhg23f().b[0][2]++, props.theme.icon.color) || (cov_19ptvhg23f().b[0][3]++, color.baseText));
  }
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: ", ";\n  margin-bottom: ", ";\n  font-size: ", ";\n  width: ", ";\n  height: ", ";\n"])), _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.xsmall, _stylingConstants.default.font.sizeL, _stylingConstants.default.font.sizeM, _stylingConstants.default.font.sizeM));
var _default = exports.default = ProductDescriptionIcon;